<template>
    <div class="SingleBox"  onselectstart='return false' onselect='return false' oncontextmenu='return false'>
        <PublicHead1></PublicHead1>
        <div class="Single">
            <div class="location">
                <img class="icon_home" src="@/assets/front/icon-home.png" />
                <span
                    ><router-link :to="{ path: '/product-list' }"
                        >首页</router-link
                    ></span
                >
            </div>
            <p class="single_title">{{ content.title }}</p>
            <div class="Infos" v-html="content.info">{{ content.info }}</div>
        </div>

        <PublicFoot></PublicFoot>
    </div>
</template>

<script>
import PublicHead1 from "@/pages/front/components/head1.vue";
import PublicFoot from "@/pages/front/components/foot.vue";
import { getSingle } from "@/api/gm/api-single";
export default {
    data() {
        return {
            content: {}
        };
    },
    components: {
        PublicHead1,
        PublicFoot
    },
    created() {
        this.fetchData();
        console.log(this.$route.params.id);
    },
    watch: {
        $route: {
            handler: function() {
                this.fetchData();
            }
        }
    },
    methods: {
        //..获取数据
        fetchData() {
            if (this.$route.params.id) {
                getSingle(this.$route.params.id).then(res => {
                    this.content = res.data;
                });
            } else {
                this.content = {};
            }
        }
    }
};
</script>
<style lang="less" scoped>
body {
    background: url(../../../assets/front/icon-loginbg.png) center bottom
        no-repeat;
}
html,
body {
    height: 100%;
    min-height: 100%;
    // overflow : unset !important;
}
/deep/.logout{
  display: none;
}
/deep/.copyright {
    position: relative;
}
.SingleBox {
    background: url(../../../assets/front/icon-loginbg.png) center bottom
        no-repeat;
    position: relative;
    height: 100vh;
    // padding: 0px 0px 1vh 0px;
    overflow-y: auto;
    overflow-x: hidden;
    .Single {
        width: 1100px;
        min-height: 83vh;
        margin: 0 auto;
        .location{
          font-size:14px;
          color: #606266;
          margin: 20px auto 0px;
          img{
            position: relative;
            top:1px;
          }
          a{
            color: #313131;
            text-decoration: none;
          }
        }
        .single_title {
            text-align: center;
            font-size: 20px;
            margin: 30px auto 20px;
        }
        .Infos {
            font-size: 14px;
            line-height: 22px;
        }
    }
}

@media (max-width: 1024px) {
    .SingleBox {
        .Single {
            width: 95%;
            min-height: 78vh;
            .single_title {
                font-size: 18px;
                margin: 20px auto;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/front/single/info.vue